import { Icon, IconProps } from '@chakra-ui/react'

export function CheckIconWithBg(props: IconProps) {
  return (
    <Icon viewBox="0 0 28 28" {...props}>
      <g filter="url(#filter0_dd_48_5856)">
        <rect
          x="4"
          y="2"
          width="20"
          height="20"
          rx="4"
          fill="url(#paint0_linear_48_5856)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3563 7.4548C18.7955 7.78968 18.8801 8.41717 18.5452 8.85635L13.7796 15.1063C13.6094 15.3296 13.3532 15.471 13.0736 15.496C12.794 15.5211 12.5168 15.4274 12.3096 15.238L9.57524 12.738C9.16764 12.3654 9.13931 11.7328 9.51198 11.3252C9.88464 10.9176 10.5172 10.8893 10.9248 11.262L12.8522 13.0242L16.9548 7.64366C17.2897 7.20449 17.9172 7.11993 18.3563 7.4548Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_dd_48_5856"
          x="0"
          y="0"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.223529 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48_5856"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.223529 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_48_5856"
            result="effect2_dropShadow_48_5856"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_48_5856"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_48_5856"
          x1="8.81675"
          y1="8.33085"
          x2="33.7717"
          y2="19.6426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0060FF" />
          <stop offset="1" stopColor="#00FFBD" />
        </linearGradient>
      </defs>
    </Icon>
  )
}
